module.exports = __webpack_public_path__ + "img/54.590793b0.jpg";